import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { getStandardHeaders } from '../../util/StandardRequestHeaders';

type ApteanAdminUser = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

type ApteanAdminUsersQuery = {
  apteanAdmins: ApteanAdminUser[];
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const QUERY_APTEAN_ADMIN_USERS = gql`
  query apteanAdminUsers {
    apteanAdmins {
      id
      firstName
      lastName
      email
    }
  }
`;

export const queryApteanAdminUsers = async (
  client: ApolloClient<NormalizedCacheObject>,
): Promise<ApteanAdminUsersQuery['apteanAdmins'] | undefined> => {
  const headers = await getStandardHeaders(true);
  const { data, errors } = await client.query<ApteanAdminUsersQuery>({
    query: QUERY_APTEAN_ADMIN_USERS,
    context: { headers },
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => console.error(error));
    throw new Error('An error has occurred during the query.');
  }

  return data?.apteanAdmins;
};
